module.exports = __webpack_public_path__ + "img/20190731163214308.7d0449d5.png";